import React from 'react';
import AdminLayout from './Admin_Layout/AdminLayout';
import Weserve from '../1_home2/we_serve'

const OfferingsTable = () => {

  return (
    <AdminLayout>
      <Weserve isAdmin={true}></Weserve>
    </AdminLayout>
  );
};

export default OfferingsTable;
